import * as PIXI from "pixi.js";
import "pixi-spine";
import "pixi-particles";
import "pixi-extra-filters";

import "../libs/p3.min";

import {translate} from "./utils";

import jquery from "jquery";
global.$ = jquery;

import * as dat from 'dat.gui';
global.dat = dat;

import Main from './Main';

const main = new Main(1024, 768);
main.init();